import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Button,
  Container,
  Dialog,
  Typography,
  CircularProgress,
} from "@mui/material";
import styles from "./clientsConfirmationBalanceDialogStyles.js";
import useLogout from "../../../hooks/auth/authHook.js";
import { notification } from "../../../utils/Notifications";
import { reduceBalance, addBalance } from "../../../api/userApi";

ClientsConfirmationBalanceDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default function ClientsConfirmationBalanceDialog({
  onClose,
  open,
  balances,
  action,
  name,
  idUser,
  commentary,
  fetchClientBalance,
  setCommentary,
  setBalances
}) {
  const [logout] = useLogout();

  const [isLoading, setIsLoading] = useState(false);

  const handleDialogClose = (event, reason) => {
    if (reason === "backdropClick") {
      return;
    }
    onClose();
  };

  const handleUpdateCreditsClick = () => {
    if (isLoading) {
      return;
    }
    setIsLoading(true);

    if (action === "Remover") {
      reduceBalance(idUser, balances, commentary)
        .then((response) => {
          if (response.data.status_Code === 200) {
            notification({ text: "Saldo removido", type: "success" });
            fetchClientBalance();
            onClose();
          } else if (response.data.status_Code === 401) {
            notification({
              text: "Sesión expirada. Por favor, inicia sesión nuevamente.",
              type: "error",
            });
            logout();
          } else {
            notification({
              text: "Error al remover el saldo",
              type: "error",
            });
          }
        })
        .catch(() => {
          setIsLoading(false);
          notification({
            text: "Error de conexión, revisa tu conexión a internet",
            type: "error",
          });
        });
    }

    if (action === "Agregar") {
      addBalance(idUser, balances, commentary)
        .then((response) => {
          if (response.data.status_Code === 200) {
            notification({ text: "Saldo agregado", type: "success" });
            fetchClientBalance();
            onClose();
          } else if (response.data.status_Code === 401) {
            notification({
              text: "Sesión expirada. Por favor, inicia sesión nuevamente.",
              type: "error",
            });
            logout();
          } else {
            notification({
              text: "Error al agregar el saldo",
              type: "error",
            });
          }
        })
        .catch(() => {
          setIsLoading(false);
          notification({
            text: "Error de conexión, revisa tu conexión a internet",
            type: "error",
          });
        });
    }

    setCommentary('');
    setBalances(0);
  };

  return (
    <Dialog
      onClose={handleDialogClose}
      open={open}
      PaperProps={{ style: styles.dialog }}
    >
      <Container style={styles.mainContainer}>
        <Typography component="div" variant="h5" style={styles.title}>
          {action} saldo
        </Typography>
        <Typography component="div" variant="body1" style={styles.subtitle}>
          Se {action.toLowerCase()}án {balances} al saldo del usuario {name}
        </Typography>
        { commentary && <Typography component="div" variant="body1" style={styles.subtitle}>
          <strong>Comentario: </strong>{commentary}
        </Typography>}

        <Container style={styles.buttonsContainer}>
          <Button
            variant="standard"
            color="primary"
            onClick={handleDialogClose}
            style={styles.cancelButton}
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              handleUpdateCreditsClick();
            }}
            sx={styles.activeButton}
          >
            {isLoading ? (
              <CircularProgress size={24} style={styles.circularProgress} />
            ) : (
              action
            )}
          </Button>
        </Container>
      </Container>
    </Dialog>
  );
}
